import React, { Component } from 'react';
import { Carousel } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';


class Main extends Component {
    constructor(props) {
        super(props)
        this.state = {
            count: 1,
            maxMintAmount: 5
        }
    }

    render() {


        /*
                const incrementCount = () => {
                    if (this.state.count < this.state.maxMintAmount) {
                        this.setState({ count: this.state.count + 1 })
                    }
                };
        
                const decrementCount = () => {
                    if (this.state.count > 1) {
                        this.setState({ count: this.state.count - 1 })
                    }
                };
        */
        //console.log("listem : ", this.props.mynftList[0])
        //<iframe title="oyun " src="https://metascene.herokuapp.com/" width={1000} height={650} > </ iframe >

        return (
            <div id="content">
                <center>
                    <hr></hr>

                    <h2 id="scene">MetaMall Scene</h2>
                    <div className="divide-y divide-gray-100">
                        <div className="py-8 space-y-8 text-base leading-6 text-gray-700 sm:text-lg sm:leading-7">
                            <br />
                            <ul className="space-y-2 list-disc listem">
                                <li className="flex items-start">
                                    <p className="ml-5">
                                        Comming Soon! (After PreSale)
                                    </p>
                                    <p className="ml-2">
                                        Here, we will enjoy visiting the metaverse shopping malls where all the NFTs in the collection are connected.
                                    </p>
                                    <p className="ml-2">
                                        In this scene, similar to a multiplayer game,
                                        all nft buyers will be able to see the location of their store in the mall.
                                    </p>
                                    <p className="ml-2">
                                        However, everyone will be able to get a chance to own a store they
                                        like in the metaverse mall by making a price offer in markets such as Opensea.
                                    </p>
                                    <p className="ml-2">
                                        The reason we haven't activated this stage right now is to keep
                                        everyone's chances of winning fairly. After the presale limits are completed,
                                        the parity and rank values ​​of the nfts belonging to the shopping mall stores will also be displayed.
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        Every nft you will have in this project will be able to turn into a terrable investment tool in the metaverse mall.
                                    </p>
                                </li>
                            </ul>
                        </div>
                        <br />
                        <br />
                    </div>

                    <hr></hr>
                    <h2 id="mynfts">Your Stores (NFTs)</h2>
                    {this.props.mynftList.length > 0 ?
                        <Carousel>
                            {
                                this.props.mynftList.map((name, index) => (
                                    <Carousel.Item key={index} interval={1500}>
                                        <img
                                            className="d-block w-200"
                                            src="metamall.gif"
                                            alt="Resim"
                                        />
                                        <Carousel.Caption>
                                            <h3>URL: {name.url}</h3>
                                            <p>Store Nft #{index + 1}</p>
                                        </Carousel.Caption>
                                    </Carousel.Item>
                                )
                                )

                            }
                        </Carousel>
                        :
                        <div>
                            <h4>You currently do not have any nft in this project.</h4>
                            <h4>You can see your nfts in this section when you have them.</h4>

                        </div>
                    }

                    <hr></hr>
                    <br />
                    <h2>Change Your Nft's Real Store URL</h2>
                    {this.props.mynftList.length >= 0 ?
                        <form onSubmit={(event) => {
                            event.preventDefault()
                            this.props.urlDegis(event.target.newId.value, event.target.newUrl.value)
                        }}>
                            <br />
                            <p>
                                <span />
                                <div className="form-group row">
                                    <div className="col-md-3">
                                        <label for="currentPassword" >Token ID :</label>
                                    </div>

                                    <div class="col-md-6">
                                        <input
                                            id="newId"
                                            type="text"
                                            ref={(input) => { this.nftId = input }}
                                            className="form-control"
                                            placeholder="Your Nft's Id"
                                            required />
                                    </div>

                                </div>
                            </p>

                            <div class="form-group row">
                                <div className="col-md-3">
                                    <label for="currentPassword">Web URL :</label>
                                </div>
                                <div className="col-md-6">
                                    <input
                                        id="newUrl"
                                        type="text"
                                        ref={(input) => { this.nftUrl = input }}
                                        className="form-control"
                                        placeholder="Real Store Web Url"
                                        required />
                                </div>
                            </div>
                            <br />
                            <button type="submit" className="btn btn-primary">Change URL</button>

                        </form>

                        :
                        <div>
                            <h4>You currently do not have any nft in this project.</h4>
                            <h4>Once you have it, you will be able to update the real world store urls of your nfts in this section.</h4>
                        </div>
                    }
                    <br />
                    <hr></hr>
                    <br />
                    <h2 id="presale">Presale Mint Nft (0.003 ETH)</h2>
                    <br />
                    <h2>(Only Whitelist)</h2>
                    {this.props.onsatisAktifmi ?
                        <form onSubmit={(event) => {

                            event.preventDefault()
                            //alert(event.target.adet.value)
                            //this.props.urlDegis(this.nftId.valueAsNumber, this.nfrUrl.value)
                            this.props.presaleMint(event.target.adet.value)
                            //console.log("Premint'e tıklandı...")

                        }}>
                            <br />
                            <p>
                                <span />
                                <div className="form-group row">
                                    <div className="col-md-3">
                                        <label for="currentPassword" >Token Count (Max. 5) :</label>
                                    </div>

                                    <div class="col-md-6">
                                        <input
                                            id="adet"
                                            type="text"
                                            ref={(input) => { this.nftAdet = input }}
                                            className="form-control"
                                            placeholder="Token Count"
                                            required />
                                    </div>

                                </div>
                            </p>

                            <br />
                            <button type="submit" className="btn btn-primary">Mint Now!</button>




                        </form>
                        :
                        <div>
                            <p className="text-white text-2xl mt-8">
                                {" "}
                                😥 preSale is not active yet!
                            </p>
                        </div>
                    }
                    <br />
                    <br />
                    <hr />
                    <h2 id="sale">Mint Nft (0.006 ETH)</h2>
                    {this.props.satisAktifmi ?
                        <form onSubmit={(event) => {

                            event.preventDefault()
                            //alert(event.target.adet.value)
                            //this.props.urlDegis(this.nftId.valueAsNumber, this.nfrUrl.value)
                            this.props.saleMint(event.target.adet.value)

                        }}>
                            <br />
                            <p>
                                <span />
                                <div className="form-group row">
                                    <div className="col-md-3">
                                        <label for="currentPassword" >Token Count (Max. 200) :</label>
                                    </div>

                                    <div class="col-md-6">
                                        <input
                                            id="adet"
                                            type="text"
                                            ref={(input) => { this.nftAdet = input }}
                                            className="form-control"
                                            placeholder="Token Count"
                                            required />
                                    </div>

                                </div>
                            </p>

                            <br />
                            <button type="submit" className="btn btn-primary">Mint Now!</button>




                        </form>
                        :
                        <div>
                            <p className="text-white text-2xl mt-8">
                                {" "}
                                😥 Sale is not active yet!
                            </p>
                        </div>
                    }
                    <br />
                    <br />
                </center>
            </div>
        );
    }
}

export default Main;